import React, { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi"; // ✅ ADD THIS
import DynamicTable from "../ReusableComponent/DynamicTable";
import "../../styles/students.css";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import {
  getWithTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../../util/Api";
import {
  students_list,
  students_list_approved,
  students_list_autoapproved,
  students_list_pannding,
} from "../../util/Apiendpoits";
import { SafeToast } from "../Toast/ShowToast";
import { State } from "country-state-city";
import TableSkeleton from "../ReusableComponent/TableSkeleton";
import ApprovedDropdown from "./ApprovedDropdown";

const StudentsComponent = () => {
  const [activeTab, setActiveTab] = useState("Pending");
  const { token, roleType, userId } = useSelector((state) => state.auth);
  const tabs = ["Pending", "Approved", "Auto Approval"];
  const [students, setStudents] = useState([]);
  console.log(students[0]?.instituteid, "setStudents");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [citysearch, setCitySearch] = useState("");
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    const indianStates = State.getStatesOfCountry("IN");
    const formattedStates = indianStates.map((state) => ({
      value: state.isoCode,
      label: state.name,
    }));
    setStateOptions(formattedStates);
  }, []);

  const handleVerifyClick = (row) => {
    setSelectedStudent(row);
    setOpenDialog(true);
  };

  const closeDialog = () => {
    setSelectedStudent(null);
  };

  const handleCheckboxChange = (studentId, checked) => {
    setSelectedRows((prev) => {
      if (checked) return [...prev, studentId];
      else return prev.filter((id) => id !== studentId);
    });
  };

  const approveStudent = async (studentId, action) => {
    const payload = {
      adminId: userId,
      isActive: true,
      ...(action === "approved" && { isApproved: true }),
      ...(action === "blocked" && { isBlocked: true }),
      ...(action === "unblock" && { isBlocked: false }),
      // isBlocked: action === "blocked",
    };

    try {
      const res = await putWithTokenAPI(
        token,
        `/admin/subscription/${studentId}/approve`,
        payload,
      );
      if (res?.success) {
        SafeToast.success(`Student ${action} successfully`);

        handleFetchStudents(activeTab, search, citysearch, selectedFilters);
      } else {
        SafeToast.error(res?.message || "Failed to approve student");
      }

      return res;
    } catch (error) {
      console.error("Error approving student:", error);
      SafeToast.error("Failed to approve student");
      throw error; // Re-throw if you want to handle it elsewhere
    }
  };

  const handleBuleActionBlock = async (selected) => {
    const payload = {
      approvedBy: userId,
      isActive: true,
      subscriptionIds: selectedRows,
      isBlocked: selected === "blocked",
    };

    try {
      const res = await putWithTokenAPI(
        token,
        `/admin/user-subscriptions/bulk-update`,
        payload,
      );
      if (res?.success) {
        SafeToast.success(`Student ${selected} successfully`);

        handleFetchStudents(activeTab, search, citysearch, selectedFilters);
      } else {
        SafeToast.error(res?.message || "Failed to approve student");
      }
      setSelectedRows([]);
      return res;
    } catch (error) {
      console.error("Error approving student:", error);
      SafeToast.error("Failed to approve student");
      throw error; // Re-throw if you want to handle it elsewhere
    }
  };

  const handleBuleActionApproved = async (selected) => {
    const payload = {
      approvedBy: userId,
      isActive: true,
      subscriptionIds: selectedRows,
      isApproved: true,
    };

    try {
      const res = await putWithTokenAPI(
        token,
        `/admin/user-subscriptions/bulk-update`,
        payload,
      );
      if (res?.success) {
        SafeToast.success(`Student ${selected} successfully`);

        handleFetchStudents(activeTab, search, citysearch, selectedFilters);
      } else {
        SafeToast.error(res?.message || "Failed to approve student");
      }
      setSelectedRows([]);
      return res;
    } catch (error) {
      console.error("Error approving student:", error);
      SafeToast.error("Failed to approve student");
      throw error; // Re-throw if you want to handle it elsewhere
    }
  };

  const getColumns = () => {
    if (activeTab == "Pending") {
      return [
        {
          key: "name",
          label: "Name",
          render: (row) => (
            <a
              href={`/students/profile/student/${row.userid}/institute/${row.instituteid}/batchId/${row.batchId}`}
              style={{
                color: "#2563eb", // text-blue-600
                textDecoration: "none", // remove underline
              }}
            >
              {row.name}
            </a>
          ),
        },
        {
          key: "phone",
          label: "Phone Number",
          render: (row) => row.phone,
        },
        {
          key: "examType",
          label: "Exam Type",
          render: (row) => {
            return (
              <div>
                <div>{row.examType}</div>
                <div>{row.headline}</div>
              </div>
            );
          },
        },
        {
          key: "city",
          label: "City",
          render: (row) => row.city,
        },

        {
          key: "date",
          label: "Date",
          render: (row) => row.date,
        },
        {
          key: "verification",
          label: "Verification",
          render: (row) => (
            <button
              className={`verify-btn ${row.verified ? "active" : ""}`}
              onClick={() => {
                if (row.verified) {
                  handleVerifyClick(row);
                } else {
                  SafeToast.info("Student has not uploaded the document yet!");
                }
              }}
            >
              {row.verified ? <FiEye /> : <FiEye />}
            </button>
          ),
        },
        {
          key: "select",
          label: "Select",
          render: (row) => (
            <div
              className="selectcheckbox"
              style={{
                width: "60%",
                paddingLeft: "10%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span
                className="approved-selectcheckbox"
                style={{ cursor: "pointer" }}
                onClick={() => approveStudent(row.id, "approved")}
              >
                {/* {row.status} */}
                Approve
              </span>

              <label className="custom-checkbox">
                <input
                  type="checkbox"
                  checked={selectedRows.includes(row.id)}
                  onChange={(e) =>
                    handleCheckboxChange(row.id, e.target.checked)
                  }
                />
                <span className="checkmark"></span>
              </label>
            </div>
          ),
        },
      ];
    }

    return [
      {
        key: "name",
        label: "Name",
        render: (row) => (
          <a
            href={`/students/profile/student/${row.userid}/institute/${row.instituteid}/batchId/${row.batchId}`}
            style={{
              color: "#2563eb", // text-blue-600
              textDecoration: "none", // remove underline
            }}
          >
            {row.name}
          </a>
        ),
      },
      {
        key: "phone",
        label: "Phone Number",
        render: (row) => row.phone,
      },
      {
        key: "examType",
        label: "Exam Type",
        render: (row) => {
          return (
            <div>
              <div>{row.examType}</div>
              <div>{row.headline}</div>
            </div>
          );
        },
      },
      {
        key: "city",
        label: "City",
        render: (row) => row.city,
      },
      {
        key: "option",
        label: "Option",
        render: (row) => (
          <ApprovedDropdown
            value={row.isBlocked ? "blocked" : "unblock"}
            onChange={async (selectedValue) => {
              await approveStudent(row.id, selectedValue);
            }}
            options={[
              { value: "blocked", label: "Block" },
              { value: "unblock", label: "Unblock" },
            ]}
          />
        ),
      },
      {
        key: "verification",
        label: "Verification",
        render: (row) => (
          <button
            className={`verify-btn ${row.verified ? "active" : ""}`}
            onClick={() => {
              if (row.verified) {
                handleVerifyClick(row);
              } else {
                SafeToast.info("Student has not uploaded the document yet!");
              }
            }}
          >
            {row.verified ? <FiEye /> : <FiEye />}
          </button>
        ),
      },
      {
        key: "select",
        label: "Select",
        render: (row) => (
          <div className="selectcheckbox">
            <label className="custom-checkbox">
              <input
                type="checkbox"
                checked={selectedRows.includes(row.id)}
                onChange={(e) => handleCheckboxChange(row.id, e.target.checked)}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        ),
      },
    ];
  };

  const monthOptions = [
    // { value: "", label: "All Months" },
    { value: "1", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const getYearOptions = (startYear = 2020) => {
    const currentYear = new Date().getFullYear() + 1;
    const years = [];

    for (let year = currentYear; year >= startYear; year--) {
      years.push({
        value: year,
        label: `${year}`,
      });
    }

    return years;
  };
  const yearOptions = getYearOptions(2025);

  // const filters = [
  //   { key: "state", label: "State", options: stateOptions, rowKey: "state" },
  //   {
  //     key: "institution",
  //     label: "Institution",
  //     options: institutionOptions,
  //     rowKey: "institution",
  //   },
  //   { key: "month", label: "Month", options: monthOptions, rowKey: "month" },
  //   { key: "year", label: "Year", options: yearOptions, rowKey: "year" },
  // ];
  const [examOptions, setExamOptions] = useState([]);
  const cityOptions = useMemo(() => {
    const uniqueCities = [
      ...new Set(students.map((s) => s.city).filter(Boolean)),
    ];

    return uniqueCities.map((city) => ({
      value: city,
      label: city,
    }));
  }, [students]);
  const filters = useMemo(
    () => [
      {
        key: "examType",
        label: "Exam Type",
        options: examOptions,
      },
      {
        key: "city",
        label: "City",
        options: cityOptions,
      },
      {
        key: "month",
        label: "Month",
        options: monthOptions,
      },
      {
        key: "year",
        label: "Year",
        options: yearOptions,
      },
    ],
    [examOptions, cityOptions],
  );

  const [selectedFilters, setSelectedFilters] = useState(
    filters.reduce((acc, filter) => {
      acc[filter.key] = null;

      return acc;
    }, {}),
  );

  const handleFilterChange = (key, option) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [key]: option,
    }));
  };
  // const getApiByTab = (tab) => {
  //     switch (tab) {
  //         case "Pending":
  //             return students_list_pannding;

  //         case "Auto Approval":
  //             return students_list_autoapproved;

  //         case "Approved":
  //         default:
  //             return students_list_approved;
  //     }
  // };
  const getApiByTab = (tab) => {
    const isInstitutionAdmin = roleType === "institution_admin";
    const appendInstitutionId = (url) => {
      if (isInstitutionAdmin && userId) {
        return url.includes("?")
          ? `${url}&institutionId=${userId}`
          : `${url}?institutionId=${userId}`;
      }
      return url;
    };

    switch (tab) {
      case "Pending":
        return appendInstitutionId(students_list_pannding);

      case "Auto Approval":
        return appendInstitutionId(students_list_autoapproved);

      case "Approved":
      default:
        return appendInstitutionId(students_list_approved);
    }
  };

  const transformStudentsData = (apiData, activeTab) => {
    return apiData.map((item) => ({
      id: item._id,
      userid: item.userId?._id,
      batchId: item.batchId?._id,
      instituteid: item.institutionId?._id,
      name: item.userId?.name,
      phone: item.userId?.phoneNumber,
      institution: item.institutionId?.nameofInstitution,
      examType: item.batchId?.examType?.value,
      headline: item.batchId?.headlineTagline,
      state: item.userId?.state,
      city: item?.userId?.city,
      date: new Date(item.createdAt).toLocaleDateString("en-GB"),
      verified: item.upload_img,
      status: activeTab === "Pending" ? "Approved" : "Blocked",
      isBlocked: item.isBlocked,
    }));
  };

  const buildQueryParams = (searchValue, cityValue, filters) => {
    const params = new URLSearchParams();

    if (searchValue) {
      params.append("search", searchValue);
    }
    if (cityValue) {
      params.append("city", cityValue); // 👈 ADD THIS
    }

    Object.keys(filters).forEach((key) => {
      if (filters[key]?.value) {
        params.append(key, filters[key].value);
      }
    });

    return params.toString();
  };
  const [tableLoading, setTableLoading] = useState(false);
  const handleFetchStudents = async (
    tab,
    searchValue = "",
    cityValue = "",
    filters = {},
  ) => {
    try {
      setTableLoading(true);
      const apiUrl = getApiByTab(tab);

      const queryString = buildQueryParams(searchValue, cityValue, filters);

      const finalUrl = queryString ? `${apiUrl}&${queryString}` : apiUrl;

      const res = await getWithTokenAPI(token, finalUrl);
      const formattedData = transformStudentsData(res?.data || [], tab);
      if (res.success) {
        setActiveTab(activeTab);
        setStudents(formattedData);
      }
    } catch (error) {
      SafeToast.error("Fetch students error:", error);
    } finally {
      setTableLoading(false);
      setFirstLoad(false);
    }
  };

  useEffect(() => {
    if (roleType === "superadmin" || roleType === "institution_admin") {
      const delay = setTimeout(() => {
        handleFetchStudents(activeTab, search, citysearch, selectedFilters);
      }, 500);

      return () => clearTimeout(delay);
    }
  }, [roleType, activeTab, selectedFilters, search, citysearch]);

  useEffect(() => {
    if (selectedStudent) {
      document.body.style.overflow = "hidden";
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedStudent]);

  const fetchExams = async (instituteId) => {
    if (!instituteId) return;

    try {
      const res = await getWithTokenAPI(token, `/user/${instituteId}/exams`);

      if (
        res?.message === "User exams fetched successfully" &&
        Array.isArray(res?.data?.exams)
      ) {
        const options = res.data.exams.map((item) => ({
          value: item.value,
          label: item.value,
        }));

        setExamOptions(options);
      }
    } catch (error) {
      console.error("Institution fetch error", error);
    }
  };

  useEffect(() => {
    if (roleType === "institution_admin" && userId) {
      fetchExams(userId);
    }
  }, [roleType, userId]);

  return (
    <div className="students-container">
      <div className="student-header">
        <div className="student-title">
          <h1>{roleType === "superadmin" ? "Students" : "Institution"}</h1>
        </div>
        <div className="tab-wrapper">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab-btn ${activeTab === tab ? "active" : ""}`}
              onClick={() => {
                setActiveTab(tab);
                setSelectedRows([]);
              }}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {tableLoading ? (
        <TableSkeleton columns={getColumns()} rows={6} hasActions={true} />
      ) : (
        <DynamicTable
          columns={getColumns()}
          data={students}
          filters={filters}
          search={search}
          setSearch={setSearch}
          selectedFilters={selectedFilters}
          handleFilterChange={handleFilterChange}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          activeTab={activeTab}
          onSearchClick={handleFetchStudents}
        />
      )}
      {selectedStudent && (
        <div className="modal-backdrop" onClick={closeDialog}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="modal-header">
              <h3 className="modal-header-title">Victory Batch</h3>
              <button onClick={closeDialog}>✕</button>
            </div>

            {/* Body */}
            <div className="receipt-box">
              {/* Verification Image */}
              {selectedStudent?.verified ? (
                <img
                  src={selectedStudent.verified} // upload_img
                  alt="Verification"
                  className="receipt-img verified-img"
                />
              ) : (
                <div className="no-img">No Verification Image</div>
              )}

              {/* Student Info */}
              <div className="info-box">
                <p>
                  <b>Name</b>
                </p>
                <div className="info">{selectedStudent?.name}</div>

                <p>
                  <b>Mobile</b>
                </p>
                <div className="info">{selectedStudent?.phone}</div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="bulk-actions">
        {selectedRows.length > 1 && (
          <>
            {activeTab == "Pending" ? (
              <span
                className="approved-selectcheckbox"
                style={{ cursor: "pointer" }}
                onClick={() => handleBuleActionApproved()}
              >
                Approve All
              </span>
            ) : (
              // <select className="approved-dropdown"
              //     onChange={async (e) => {
              //         const selected = e.target.value;
              //         handleBuleActionBlock(selected)
              //     }}
              // >
              //     <option value={"blocked"}>Block All</option>
              //     <option value={"unblock"}>Unblock All</option>
              // </select>
              <ApprovedDropdown
                value="select" // default selected value
                onChange={async (selectedValue) => {
                  // Call your function when the user selects an option
                  await handleBuleActionBlock(selectedValue);
                }}
                options={[
                  { value: "blocked", label: "Block All" },
                  { value: "unblock", label: "Unblock All" },
                ]}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StudentsComponent;
